import React from "react";
import useCountdown from "../../hook/useCountdown";
import { usePassText } from "./passI18n";

const pad = (value) => String(value).padStart(2, "0");

export default function PassPromoCountdown({ endDate }) {
  const translate = usePassText();
  const { available, days, hours, minutes, seconds } = useCountdown(endDate);

  if (!available) return null;

  const units = [
    { key: "days", value: pad(days), label: translate("DOTORE_PASS.PROMO.COUNTDOWN.DAYS") },
    { key: "hours", value: pad(hours), label: translate("DOTORE_PASS.PROMO.COUNTDOWN.HOURS") },
    { key: "minutes", value: pad(minutes), label: translate("DOTORE_PASS.PROMO.COUNTDOWN.MIN") },
    { key: "seconds", value: pad(seconds), label: translate("DOTORE_PASS.PROMO.COUNTDOWN.SEC") },
  ];

  return (
    <div className="dp-promo-countdown" role="timer" aria-live="off">
      {units.map((unit) => (
        <div className="dp-promo-countdown-unit" key={unit.key}>
          <span className="dp-promo-countdown-tile">
            <span className="dp-promo-countdown-value">{unit.value}</span>
          </span>
          <span className="dp-promo-countdown-label">{unit.label}</span>
        </div>
      ))}
    </div>
  );
}
